import { useHostPage } from "../hooks/use-host-page";

export const EmbedIFrame = ({
  src,
  scope = "*",
  events = {},
  params = {},
  ...props
}) => {
  const host = useHostPage(src, () => ({
    scope,
    params,
    events
  }));

  return <iframe frameBorder="0" {...props} src={host.url} />;
};
